import React from "react";
import send from "../../assets/tabler-icon-send.svg";
import { useGlobalContext } from "../../context/Appcontext";
import { TextField, IconButton, InputAdornment,Box } from "@mui/material";

const InputBar = () => {
  const { messageText, setMessageText, handleSubmission } = useGlobalContext();

  return (
    <Box display="flex" justifyContent="center" alignItems="center" width="100%" mt={2} mb={5} ml={18}>
    <TextField
      fullWidth
      variant="outlined"
       autoComplete="off"
      placeholder="Ask me anything..."
      value={messageText}
      onChange={(event) => setMessageText(event.target.value)}
      onKeyUp={(event) => {
        if (event.key === "Enter" && !event.shiftKey) {
          event.preventDefault();
          handleSubmission();
        }
      }}
      sx={{
        width: "40%",
        "& .MuiOutlinedInput-root": {
          padding: "5px",
          borderRadius: "40px",
          backgroundColor: "#F5F7FB",
          "& fieldset": {
            border: "none",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
        },
        "& .MuiInputBase-input": {
          padding: "16px 24px",
          border: "none",
        },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={handleSubmission}
              sx={{
                backgroundColor: "#E39121",
                color: "white",
                padding: "5px",
                borderRadius: "50%",
              }}
            >
              <img src={send} alt="send" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
    </Box>
  );
};

export default InputBar;
